import * as React from 'react';
import deepmerge from 'deepmerge';
import { MapStateProvider } from './map-state-context';
import { MapProvider as MapGlProvider } from 'react-map-gl';
import { MapConfigProvider, defaultMapConfig } from './map-config-context';
import { EntityTypeMapMarkersProvider } from './entity-type-map-markers-context';
export var MapProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  var config = deepmerge(defaultMapConfig, value || {});
  return React.createElement(MapConfigProvider, {
    value: config
  }, React.createElement(EntityTypeMapMarkersProvider, {
    value: config.entityTypeMapMarkers
  }, React.createElement(MapGlProvider, null, React.createElement(MapStateProvider, {
    value: config.initialMapState
  }, children))));
};